import bannerImg from '../../assets/images/banner1.jpeg'

const Banner = () => {
    return (
        <div className="banner-wrapper" id="join" data-aos="fade" data-aos-offset="0">
        </div>
    )
}

export default Banner
